import { useNavigate } from 'react-router-dom';

// project imports
import useAuth from 'hooks/useAuth';
import { GuardProps } from 'types';
import { useEffect } from 'react';


// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const { isLoggedIn, user } = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (!isLoggedIn) {
            navigate('/backoffice/login', { replace: true });
            return;
        }

        const checkAccess = () => {
            const currentIndex = document.location.pathname.split('/');
            const access = user?.route_access;

            if (access && access[currentIndex[1]]) {
                const value = access[currentIndex[1]];
                if (!value.read) {
                    navigate('/not-found', { replace: false });
                    return;
                }
                if (currentIndex[2] !== undefined) {
                    if (!value.read && currentIndex[2] === 'view') {
                        navigate('/not-found', { replace: false });
                        return;
                    }
                    if (!value.add && currentIndex[2] === 'create') {
                        navigate('/not-found', { replace: false });
                        return;
                    }
                    if (!value.edit && currentIndex[2] === 'update') {
                        navigate('/not-found', { replace: false });
                        return;
                    }
                    if (!value.delete && currentIndex[2] === 'delete') {
                        navigate('/not-found', { replace: false });
                        return;
                    }
                }
            } else if (currentIndex[1] !== 'dashboard') {
                navigate('/not-found', { replace: false });
                return;
            }
        };

        checkAccess();

    }, [isLoggedIn, navigate, user]);

    return children;
};

export default AuthGuard;
